import { render, staticRenderFns } from "./newServices.vue?vue&type=template&id=b582fca4"
import script from "./newServices.vue?vue&type=script&lang=js"
export * from "./newServices.vue?vue&type=script&lang=js"
import style0 from "./newServices.vue?vue&type=style&index=0&id=b582fca4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports